import React from 'react';
import { Box, Button, IconButton, TextField, Typography, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

interface ScalingControlsProps {
  originalServings: number;
  scaledServings: number;
  onServingsChange: (newServings: number) => void;
  onReset: () => void;
  isScaled: boolean;
}

const ScalingControls: React.FC<ScalingControlsProps> = ({
  originalServings,
  scaledServings,
  onServingsChange,
  onReset,
  isScaled,
}) => {
  const handleIncrement = () => {
    onServingsChange(scaledServings + 1);
  };

  const handleDecrement = () => {
    if (scaledServings > 1) {
      onServingsChange(scaledServings - 1);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value) && value > 0) {
      onServingsChange(value);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        py: 1.5,
        px: 2,
        bgcolor: 'grey.50',
        borderRadius: 1,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant='body1' sx={{ fontWeight: 500 }}>
        Servings:
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <IconButton
          size='small'
          onClick={handleDecrement}
          disabled={scaledServings <= 1}
          aria-label='Decrease servings'
        >
          <RemoveIcon fontSize='small' />
        </IconButton>

        <TextField
          type='number'
          value={scaledServings}
          onChange={handleInputChange}
          inputProps={{
            min: 1,
            step: 1,
            'aria-label': 'Number of servings',
            style: { textAlign: 'center', width: '50px' },
          }}
          size='small'
          sx={{
            width: '80px',
            '& .MuiOutlinedInput-root': {
              bgcolor: 'white',
            },
          }}
        />

        <IconButton size='small' onClick={handleIncrement} aria-label='Increase servings'>
          <AddIcon fontSize='small' />
        </IconButton>
      </Box>

      {isScaled && (
        <>
          <Chip
            label={`Originally ${originalServings}`}
            size='small'
            variant='outlined'
            color='primary'
          />
          <Button size='small' startIcon={<RestartAltIcon />} onClick={onReset} sx={{ ml: 'auto' }}>
            Reset
          </Button>
        </>
      )}
    </Box>
  );
};

export default ScalingControls;
